export const FETCH_ORDERS_PROFITS_START = "FETCH_ORDERS_PROFITS_START";
export const FETCH_ORDERS_PROFITS_SUCCESS = "FETCH_ORDERS_PROFITS_SUCCCESS";
export const FETCH_ORDERS_PROFITS_FAIL = "FETCH_ORDERS_PROFITS_START";